import { PageEmptyState } from '../../PageEmptyState'
import { MultipleViewTypeListActiveItemPreviewCloseButton } from '../MultipleViewTypeListActiveItemPreviewCloseButton'

import * as styles from './MultipleViewTypeListActiveItemPreviewEmpty.module.css'

function MultipleViewTypeListActiveItemPreviewEmpty({
  className = styles.MultipleViewTypeListActiveItemPreviewEmpty,
  onClosePreview,
  ...emptyStateProps
}) {
  return (
    <div className={className}>
      {onClosePreview ? (
        <div className={styles.close}>
          <MultipleViewTypeListActiveItemPreviewCloseButton
            onClose={onClosePreview}
          />
        </div>
      ) : null}
      <PageEmptyState {...emptyStateProps} />
    </div>
  )
}

export default MultipleViewTypeListActiveItemPreviewEmpty
